import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import React, { ReactNode, useState } from 'react';

import useLinkProps from '../../../../hooks/use-link-props';
import Button from '../../../ui/button';
import FeaturedLink from '../../../ui/links/featured';
import BPModal from '../../../ui/modal';
import PageTitleSEO from '../../../ui/v2/typography/page-title';
import AlertForm from './form';
import useModelVersionLink from '../../../ui/v2/vehicle-list/use-model-version-link';
import useLoggedUser from '../../../../hooks/use-logged-user';

const CreatePartAlertModal = ({
  vehicle,
  info,
}: {
  vehicle?: any;
  info: { category: string; subCategory: string };
}) => {
  const { t } = useTranslation();
  const getLink = useLinkProps();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const linkProps = useModelVersionLink({
    isPicker: false,
    have_versions: false,
    slug: vehicle?.model?.slug as string,
  });
  const user = useLoggedUser();

  return (
    <>
      <FeaturedLink variant="blackBold" onClick={() => setIsModalOpen(true)}>
        {t('common:create-part-alert')}
      </FeaturedLink>
      <BPModal
        variant="container"
        showClose={true}
        title={''}
        isOverflowVisible={false}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
      >
        <>
          <div className={cx('container', 'm-auto', 'mt-6')}>
            <div className="flex flex-col gap-4">
              <PageTitleSEO
                textAlign={'left'}
                title={t('private-area:part-alerts-create.page-tile') as string}
              />
              <h3 className="text-[20px] text-left">
                {t('private-area:part-alerts-create.page-subtitle')}
              </h3>
            </div>
            {!user && (
              <div className="container mx-auto mt-6 px-4 py-4 text-center bg-brand-10">
                <p>{t('private-area:part-alerts-create.alert')}</p>
              </div>
            )}
            <AlertForm vehicle={vehicle} info={info} />
          </div>
        </>
      </BPModal>
    </>
  );
};

export default CreatePartAlertModal;
